export const FWA_SET_SELECTED_FIELD = "FWA_SET_SELECTED_FIELD";
export const FWA_UPDATE_FIELD = "FWA_UPDATE_FIELD";
export const FWA_LOOKUP_STREET = "FWA_LOOKUP_STREET";
export const FWA_SEARCH_ADDRESS = "FWA_SEARCH_ADDRESS";
export const FWA_LOOKUP_PACKAGES = "FWA_LOOKUP_PACKAGES";
export const FWA_SET_PERSONAL_DETAILS = "FWA_SET_PERSONAL_DETAILS";
export const FWA_CHECK_ADDRESS = "FWA_CHECK_ADDRESS";
export const FWA_ADD_PACKAGE_TO_CART = "FWA_ADD_PACKAGE_TO_CART";
export const FWA_UPDATE_CUSTOMER_AND_SUBMIT = "FWA_UPDATE_CUSTOMER_AND_SUBMIT";
export const FWA_SET_CUSTOM_ADDRESS_CHECKED = "FWA_SET_CUSTOM_ADDRESS_CHECKED";
